import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';
import './AuthCallback.css';

/**
 * AuthCallback Component
 *
 * Handles the OAuth redirect from Google/Discord
 * Extracts JWT token from URL and stores it
 * Redirects user to intended destination or home
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState('processing'); // 'processing' | 'success' | 'error'
  const [error, setError] = useState(null);

  useEffect(() => {
    const processAuth = () => {
      // Handle OAuth callback
      const result = authService.handleCallback();

      if (result.success) {
        setStatus('success');

        // Short delay to show success message
        setTimeout(() => {
          // Check if there was an intended destination
          const intendedPath = localStorage.getItem('intendedDestination');

          if (intendedPath) {
            localStorage.removeItem('intendedDestination');
            navigate(intendedPath);
          } else {
            // Check if username is confirmed
            const payload = JSON.parse(atob(localStorage.getItem('jwt_token').split('.')[1]));
            if (!payload.usernameConfirmed) {
              // First time login - go to username confirmation
              navigate('/choose-username');
            } else {
              // Username already confirmed - go to play page
              navigate('/play');
            }
          }
        }, 1500);
      } else {
        setStatus('error');
        setError(result.error || 'Authentication failed');

        // Redirect to login page after showing error
        setTimeout(() => {
          navigate('/?error=' + encodeURIComponent(result.error));
        }, 3000);
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="auth-callback-page">
      <div className="auth-callback-container">
        {status === 'processing' && (
          <div className="auth-status processing">
            <div className="spinner"></div>
            <h2>Completing sign in...</h2>
            <p>Please wait while we verify your credentials</p>
          </div>
        )}

        {status === 'success' && (
          <div className="auth-status success">
            <div className="success-icon">✓</div>
            <h2>Success!</h2>
            <p>You're now signed in. Redirecting...</p>
          </div>
        )}

        {status === 'error' && (
          <div className="auth-status error">
            <div className="error-icon">✕</div>
            <h2>Authentication Failed</h2>
            <p>{error}</p>
            <p className="redirect-note">Redirecting to login page...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
